import { render } from "./SentMessages.vue?vue&type=template&id=286ddfd4&scoped=true"
import script from "./SentMessages.vue?vue&type=script&lang=js"
export * from "./SentMessages.vue?vue&type=script&lang=js"

import "./SentMessages.vue?vue&type=style&index=0&id=286ddfd4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286ddfd4"]])

export default __exports__